﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_insumos/insumos-main";

export const Route = createFileRoute("/_authenticated/insumos")({
  validateSearch: (
    s: Record<string, unknown>,
  ): { editar?: string | undefined; produtosDe?: string | undefined } => ({
    editar: typeof s["editar"] === "string" ? (s["editar"] as string) : undefined,
    produtosDe: typeof s["produtosDe"] === "string" ? (s["produtosDe"] as string) : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Insumos — Milky Moo Palmares" },
      { name: "description", content: "Cadastro de insumos, custos, mínimos e validade." },
      { property: "og:title", content: "Insumos — Milky Moo Palmares" },
      { property: "og:description", content: "Cadastro de insumos, custos, mínimos e validade." },
    ],
  }),
  component: PaginaRota,
});
